import './App.css';
import { ScrolToTop } from './components/ScrollToTop/ScrollToTop';
import { Delivery } from './sections/Delivery/Delivery';
import EmployeeLogin from './sections/EmployeeLogin/EmployeeLogin';
// import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute'; // 暫時停用

import { SKAManager } from './sections/ManagerPage/SKAManager'

import { Routes, Route, Navigate } from 'react-router-dom'

import './css/Message.css'

function App() {
  return (
    <div className="App">
      <ScrolToTop />
      <Routes>
        {/* 登入頁面 */}
        <Route path='/login' element={<EmployeeLogin />}></Route>

        {/* 受保護的路由 - 暫時停用保護 */}
        <Route path='/SKAManager/*' element={<SKAManager />}></Route>

        <Route path='/delivery' element={<Delivery />}></Route>

        <Route path="" element={<Navigate from="/" to="/delivery" />} />
      </Routes>
    </div>
  );
}

export default App;
